export default "__VITE_ASSET__YzctYwrK__"